let scene, camera, renderer, controls;
let box; // 3D box geometry
let lid; // Geometry for the lid
let handles = []; // Array to hold the handle meshes
let boxGroup; // Group for the box, lid, and handles

const limits = {
    width: { min: 7.5, max: 31 },
    depth: { min: 7.5, max: 31 },
    height: { min: 4, max: 31 },
};

let isUserInteracting = false; // Flag to check if the user is interacting

// Ініціалізація сцени
function init() {
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(25, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 20;

    // Налаштування рендера
    renderer = new THREE.WebGLRenderer({ antialias: true });
    const visualizationContainer = document.querySelector(".visualization");
    if (visualizationContainer) {
        renderer.setSize(visualizationContainer.clientWidth, visualizationContainer.clientHeight);
        visualizationContainer.appendChild(renderer.domElement);
    } else {
        console.error("Контейнер .visualization не знайдено.");
    }

    renderer.setClearColor(0xffffff); // Встановлення білого фону

    // Додавання освітлення
    const light = new THREE.DirectionalLight(0xffffff, 1);
    light.position.set(10, 10, 10).normalize();
    scene.add(light);

    // Додавання контролерів для миші
    controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.25;
    controls.enableZoom = true;

    // Створення початкової коробки
    createBoxWithHandles(10, 10, 10, true);

    // Додавання слухачів подій для взаємодії
    controls.addEventListener('start', () => isUserInteracting = true); // Коли починається взаємодія
    controls.addEventListener('end', () => isUserInteracting = false); // Коли взаємодія закінчується

    // Запуск анімації
    animate();

    // Додати обробник подій для зміни розміру вікна
    window.addEventListener("resize", () => {
        if (visualizationContainer) {
            renderer.setSize(visualizationContainer.clientWidth, visualizationContainer.clientHeight);
            camera.aspect = visualizationContainer.clientWidth / visualizationContainer.clientHeight;
            camera.updateProjectionMatrix();
        }
    });
}

function updateCameraPosition(width, height, depth) {
    // Визначаємо найбільший розмір коробки
    const maxDimension = Math.max(width, height, depth);

    // Встановлюємо відстань камери (залежить від розмірів коробки)
    const newCameraDistance = maxDimension * 3.5; 

    // Зберігаємо ізометричне положення, але коригуємо відстань
    const angle = Math.PI / 4; // Кут для ізометричного виду (45°)
    camera.position.set(
        newCameraDistance * Math.sin(angle),
        newCameraDistance * 0.2, // Опускаємо камеру нижче по осі Y (зменшено з 1 до 0.6)
        newCameraDistance * Math.cos(angle)
    );

    // Камера продовжує дивитися на центр сцени
    camera.lookAt(0, 0, 0);

    // Оновлюємо контролери орбіти
    controls.update();
}



// MAIN FUNCTION

function createBoxWithHandles(width, height, depth, withLid = false) {
    if (boxGroup) {
        scene.remove(boxGroup);
    }

    // Створення групи для коробки, кришки та ручок
    boxGroup = new THREE.Group();

    const cornerRadius = 1; // Радіус округлення кутів

    // Створення форми для нижньої частини коробки
    const shape = new THREE.Shape();
    shape.moveTo(-width / 2 + cornerRadius, -height / 2);
    shape.lineTo(width / 2 - cornerRadius, -height / 2);
    shape.quadraticCurveTo(width / 2, -height / 2, width / 2, -height / 2 + cornerRadius);
    shape.lineTo(width / 2, height / 2 - cornerRadius);
    shape.lineTo(-width / 2, height / 2 - cornerRadius);
    shape.lineTo(-width / 2, -height / 2 + cornerRadius);
    shape.quadraticCurveTo(-width / 2, -height / 2, -width / 2 + cornerRadius, -height / 2);

    // Екструзія форми для створення об'єму коробки
    const extrudeSettings = { depth: depth, bevelEnabled: false };
    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);

    geometry.center(); // Центрування геометрії коробки

    const material = new THREE.MeshBasicMaterial({ color: 0xE0E0E0, side: THREE.DoubleSide, transparent: true, opacity: 0.7 });
    box = new THREE.Mesh(geometry, material);

    // Додавання контурів коробки
    const edges = new THREE.EdgesGeometry(geometry);
    const edgeMaterial = new THREE.LineBasicMaterial({color: 0x000000, transparent: true, opacity: 0.5 });
    const edgeLines = new THREE.LineSegments(edges, edgeMaterial);

    boxGroup.add(box); // Додати коробку до групи
    boxGroup.add(edgeLines); // Додати контури

    // Додавання кришки
    if (withLid ===  true) {
        const lidGroup = createLidWithWalls(width, depth, height);
        boxGroup.add(lidGroup);
    }

    // Додавання ручок
    addHandles(width, depth, height, boxGroup);

    scene.add(boxGroup);
  
  
}

// FUNCTION FOR LID


function createLidWithWalls(width, depth, height, wallThickness = 1) {
    // Група для кришки
    const lidGroup = new THREE.Group();

    // Основна площина кришки
    const lidGeometry = new THREE.BoxGeometry(width, wallThickness, depth);
    const lidMaterial = new THREE.MeshBasicMaterial({ color: 0xE0E0E0, side: THREE.DoubleSide });
    const lidMesh = new THREE.Mesh(lidGeometry, lidMaterial);

    lidMesh.position.set(0, height / 2 + wallThickness / 30, 0); // Розташування кришки
    lidGroup.add(lidMesh);

    // Чорний контур для верхньої площини кришки
    const lidEdges = new THREE.EdgesGeometry(lidGeometry);
    const lidLine = new THREE.LineSegments(lidEdges, new THREE.LineBasicMaterial({ color: 0x000000 }));
    lidLine.position.copy(lidMesh.position);
    lidGroup.add(lidLine);

    return lidGroup;
}


// FUNCTION FOR ADDING HANDLES

function addHandles(width, depth, height, boxGroup) {
    const handleMaterial = new THREE.LineBasicMaterial({ color: 0x000000 }); // Матеріал для контуру ручки
    const handleWidth = 3; // Ширина ручки
    const handleHeight = 1; // Товщина ручки
    const handleDepth = 0.1; // Глибина ручки
    const cornerRadius = 0.5; // Радіус закруглення кутів

    // Відстань ручок від верхньої частини коробки
    const handleYPosition = height * 0.15;

    // Створення форми з округленими кутами для ручки
    const shape = new THREE.Shape();
    shape.moveTo(-handleWidth / 2 + cornerRadius, -handleHeight / 2);
    shape.lineTo(handleWidth / 2 - cornerRadius, -handleHeight / 2);
    shape.quadraticCurveTo(handleWidth / 2, -handleHeight / 2, handleWidth / 2, -handleHeight / 2 + cornerRadius);
    shape.lineTo(handleWidth / 2, handleHeight / 2 - cornerRadius);
    shape.quadraticCurveTo(handleWidth / 2, handleHeight / 2, handleWidth / 2 - cornerRadius, handleHeight / 2);
    shape.lineTo(-handleWidth / 2 + cornerRadius, handleHeight / 2);
    shape.quadraticCurveTo(-handleWidth / 2, handleHeight / 2, -handleWidth / 2, handleHeight / 2 - cornerRadius);
    shape.lineTo(-handleWidth / 2, -handleHeight / 2 + cornerRadius);
    shape.quadraticCurveTo(-handleWidth / 2, -handleHeight / 2, -handleWidth / 2 + cornerRadius, -handleHeight / 2);

    // Створення геометрії для 2D-контурів
    const handleGeometry = new THREE.BufferGeometry().setFromPoints(shape.getPoints());

    // Передня ручка (паралельна передній стінці коробки)
    const handleFront = new THREE.Line(handleGeometry, handleMaterial);
    handleFront.position.set(0, handleYPosition, depth / 2 + handleDepth / 2); // Розташування перед ручкою
    boxGroup.add(handleFront);

    // Задня ручка (паралельна задній стінці коробки)
    const handleBack = new THREE.Line(handleGeometry, handleMaterial);
    handleBack.position.set(0, handleYPosition, -depth / 2 - handleDepth / 2); // Розташування зад ручкою
    boxGroup.add(handleBack);
}



// CHECKBOX LID WITH UPDATE SIZES//

document.addEventListener("DOMContentLoaded", function () {
    const lidCheckbox = document.getElementById("defaultSizeCheckbox");
    
    // Оновлення значень і коробки при зміні стану чекбокса
    lidCheckbox.addEventListener("change", function () {
        updateMinValues();    // Оновлюємо мінімальне значення
        updateBox();          // Оновлюємо коробку з урахуванням кришки
    });

    // Оновлюємо мінімальні значення при завантаженні сторінки
    updateMinValues();
    updateBox(); // Оновлення коробки після завантаження сторінки
});

document.addEventListener("DOMContentLoaded", function () {
    const lidCheckbox = document.getElementById("defaultSizeCheckbox");
    const unitSelect = document.getElementById("unit");

    // Оновлення значень при зміні чекбокса або одиниць вимірювання
    lidCheckbox.addEventListener("change", function () {
        updateMinValues();
        updateBoxDimensions(); // Додаємо оновлення розмірів коробки
    });

    unitSelect.addEventListener("change", function () {
        updateMinValues();
        updateBoxDimensions(); // Оновлюємо коробку після зміни одиниць
    });

    // Оновлюємо значення при завантаженні сторінки
    updateMinValues();
    updateBoxDimensions(); // Додаємо для оновлення розмірів відразу при старті
});

function updateMinValues() {
    const lidCheckbox = document.getElementById("defaultSizeCheckbox");
    const heightInput = document.getElementById("height");
    const heightLabelSmall = document.querySelector('label[for="height"] small');
    const unit = document.getElementById("unit").value;

    let minHeight, maxHeight;

    if (unit === "cm") {
        minHeight = lidCheckbox.checked ? Math.floor(5.5 * 2.54) : Math.floor(4 * 2.54);
        maxHeight = Math.floor(31 * 2.54);
    } else {
        minHeight = lidCheckbox.checked ? 5.5 : 4;
        maxHeight = 31;
    }

    // Оновлюємо мінімальну та максимальну висоту відповідно до кришки
    heightInput.min = minHeight;
    heightInput.max = maxHeight;
    heightLabelSmall.textContent = `Min: ${minHeight}, Max: ${maxHeight}`;
    heightInput.placeholder = `${minHeight} - ${maxHeight}`;

    // Не очищаємо значення heightInput, щоб воно не скидалося при кожній зміні
}
function updateLimits() {
    const unit = document.getElementById("unit").value;
    
    if (unit === "cm") {
        limits.width.min = Math.floor(7.5 * 2.54);
        limits.width.max = Math.floor(31 * 2.54);
        limits.depth.min = Math.floor(7.5 * 2.54);
        limits.depth.max = Math.floor(31 * 2.54);
        limits.height.min = Math.floor(4 * 2.54);
        limits.height.max = Math.floor(31 * 2.54);
    } else {
        limits.width.min = 7.5;
        limits.width.max = 31;
        limits.depth.min = 7.5;
        limits.depth.max = 31;
        limits.height.min = 4;
        limits.height.max = 31;
    }
}





// CONVERT UNITS (INCH/SM)

function convertUnits() {
    updateLimits(); // Оновлюємо обмеження перед зміною мін/макс
    const unit = document.getElementById("unit").value;

    const inputs = [
        { id: "width", minInches: 7.5, maxInches: 31, labelId: "width-label" },
        { id: "depth", minInches: 7.5, maxInches: 31, labelId: "depth-label" },
        { id: "height", minInches: 4, maxInches: 31, labelId: "height-label" }
    ];

    inputs.forEach(input => {
        const inputField = document.getElementById(input.id);
        const label = document.getElementById(input.labelId);

        if (unit === "cm") {
            inputField.min = limits[input.id].min;
            inputField.max = limits[input.id].max;
        } else {
            inputField.min = input.minInches;
            inputField.max = input.maxInches;
        }

        inputField.placeholder = `${inputField.min} - ${inputField.max}`;
        label.innerHTML = `Min: ${inputField.min}, Max: ${inputField.max}`;
        inputField.value = ""; // Очищення поля
    });
}




function updateBox() {
    const width = parseFloat(document.getElementById("width").value) || 10;
    const depth = parseFloat(document.getElementById("depth").value) || 10;
    const height = parseFloat(document.getElementById("height").value) || 10;
    const withLid = document.getElementById("defaultSizeCheckbox").checked;

    // Видаляємо стару коробку
    if (boxGroup) {
        scene.remove(boxGroup);
    }

    // Створюємо нову коробку з урахуванням кришки
    createBoxWithHandles(width, height, depth, withLid);
    updateCameraPosition(width, height, depth); // Оновлюємо позицію камери
}


// Функція для оновлення розмірів коробки

function updateBoxDimensions() {
    // Отримуємо значення з полів або встановлюємо значення за замовчуванням (10)
    let width = parseFloat(document.getElementById("width").value) || 10;
    let depth = parseFloat(document.getElementById("depth").value) || 10;
    let height = parseFloat(document.getElementById("height").value) || 10;
    const unit = document.getElementById("unit").value; // Одиниця вимірювання (см або дюйми)
    const errorMessage = document.getElementById("error-message");

    // Масштабний коефіцієнт для візуалізації (конвертація см в умовні дюйми)
    const scaleFactor = unit === "cm" ? 1 / 2.54 : 1;

    // Перевірка значень розмірів
    let widthValid = width >= limits.width.min && width <= limits.width.max;
    let depthValid = depth >= limits.depth.min && depth <= limits.depth.max;
    let heightValid = height >= limits.height.min && height <= limits.height.max;

    // Якщо є проблеми з розміром
    if (!widthValid || !depthValid || !heightValid) {
        let errors = [];
        if (!widthValid) errors.push(`Width should be between ${limits.width.min} and ${limits.width.max}.`);
        if (!depthValid) errors.push(`Depth should be between ${limits.depth.min} and ${limits.depth.max}.`);
        if (!heightValid) errors.push(`Height should be between ${limits.height.min} and ${limits.height.max}.`);

        errorMessage.textContent = errors.join(" ");
        return; // Зупинити функцію, якщо є помилка
    }

    errorMessage.textContent = ""; // Якщо немає помилок, очищаємо повідомлення

    // Оновлюємо розмір коробки з врахуванням масштабу
    const withLid = document.getElementById("defaultSizeCheckbox").checked;
    createBoxWithHandles(width * scaleFactor, height * scaleFactor, depth * scaleFactor, withLid);

    updatePrice(); // Оновлення ціни після зміни розмірів
}




// Видаляємо автоматичне оновлення при введенні
document.getElementById("width").removeEventListener("input", updatePrice);
document.getElementById("height").removeEventListener("input", updatePrice);
document.getElementById("depth").removeEventListener("input", updatePrice);



let allowRotation = false; // Змінна для контролю обертання

function animate() {
    requestAnimationFrame(animate);

    if (allowRotation && boxGroup) {
        boxGroup.rotation.y += 0.01; // Обертання по осі Y
    }

    controls.update(); // Оновлення контролерів
    renderer.render(scene, camera); // Рендеринг сцени
}

// Запускаємо ініціалізацію
init();



/* PRICE */

// Функція для розрахунку коефіцієнта ціни
function calculateDynamicCoefficient(value) {
    let min_range, max_range, k_max, k_min;

    if (value >= 1000 && value < 1501) {  
        min_range = 1000; max_range = 1500; k_max = 0.037; k_min = 0.029;
    } else if (value >= 1501 && value < 2001) {
        min_range = 1501; max_range = 2000; k_max = 0.029; k_min = 0.027;
    } else if (value >= 2001 && value < 2501) {
        min_range = 2001; max_range = 2500; k_max = 0.027; k_min = 0.025;
    } else if (value >= 2501 && value < 3001) {
        min_range = 2501; max_range = 3000; k_max = 0.025; k_min = 0.023;
    } else if (value >= 3001 && value < 3501) {
        min_range = 3001; max_range = 3500; k_max = 0.023; k_min = 0.0195;
    } else if (value >= 3501 && value < 5001) {
        min_range = 3501; max_range = 5000; k_max = 0.0195; k_min = 0.015;
    } else if (value >= 5001 && value <= 29791) {
        min_range = 5001; max_range = 29791; k_max = 0.015; k_min = 0.0068;
    } else {
        return NaN;
    }

    const range_width = max_range - min_range;
    const coefficient = k_max - ((k_max - k_min) * (value - min_range) / range_width);

    const price = coefficient * value;

    console.log(`Об'єм: ${value}, Коефіцієнт: ${coefficient}, Ціна: ${price}`);

    return price;
}

// Функція для округлення ціни до більшого цілого
function roundPrice(price) {
    return Math.ceil(price);
}

// Функція для обчислення ціни на основі розмірів
function calculatePrice(width, height, depth, unit) {
    if (unit === "cm") {
        width /= 2.54;
        height /= 2.54;
        depth /= 2.54;
    }

    const volume = width * height * depth;

    if (volume <= 1000) {
        return 37;
    } else {
        const price = calculateDynamicCoefficient(volume);
        if (isNaN(price)) {
            console.error(`Помилка: об'єм ${volume} виходить за межі.`);
            return 0;
        }
        return roundPrice(price);
    }
}

// Функція для оновлення ціни на сторінці
function updatePrice() {
    const width = parseFloat(document.getElementById("width")?.value);
    const height = parseFloat(document.getElementById("height")?.value);
    const depth = parseFloat(document.getElementById("depth")?.value);
    const unit = document.getElementById("unit").value; // Отримуємо вибрану одиницю

    if (isNaN(width) || isNaN(height) || isNaN(depth) || width <= 0 || height <= 0 || depth <= 0) {
        document.getElementById("price").textContent = "0$";
        return;
    }

    const price = calculatePrice(width, height, depth, unit);
    document.getElementById("price").textContent = price ? `$${price.toFixed(2)}` : "0$";
}

// Додаємо слухачів подій для зміни значень
["width", "height", "depth", "unit"].forEach(id => {
    const input = document.getElementById(id);
    if (input) input.addEventListener("input", updatePrice);
});





// ADDED RECENTLY
// id variant - 44306124931222

// Функція для валідації полів
  function validateInput(inputElement) {
    const value = parseFloat(inputElement.value);
    const min = parseFloat(inputElement.min);
    const max = parseFloat(inputElement.max);
    
    if (value < min || value > max) {
      inputElement.classList.add("error");
    } else {
      document.getElementById("error-message").innerText = "";  // Очистити повідомлення про помилку
      inputElement.classList.remove("error");  // Видалити клас помилки
    }
  }

// ID PRODUCT //
fetch('/products.json')
  .then(response => response.json())
  .then(data => console.log(data));


// ADD TO CART // 

document.getElementById("add-to-cart-form").addEventListener("submit", function (event) {
    event.preventDefault(); // Відміняємо стандартний сабміт

    let width = parseFloat(document.getElementById("width").value);
    let height = parseFloat(document.getElementById("height").value);
    let depth = parseFloat(document.getElementById("depth").value);
    
    let priceText = document.getElementById("price").textContent.replace("$", "").trim();
    let calculatedPrice = parseFloat(priceText); // Отримуємо ціну, яка відображається
  
    let selectedColor = document.querySelector('input[name="Outside color"]:checked')?.value || "Not selected";
    let selectedEcoleathercolor = document.querySelector('input[name="Eco-leather color"]:checked')?.value || "Not selected";
  
    let hasLid = document.getElementById("defaultSizeCheckbox").checked ? "Yes" : "No";
    let unit = document.getElementById("unit").value;

    console.log("🔹 Entered dimensions:", { width, height, depth });
    console.log("🔹 Calculated price:", calculatedPrice);

    // *** Валідація ***
    let isValid = true;

    function validateDimension(value, min, max, elementId) {
        const element = document.getElementById(elementId);
        if (isNaN(value) || value < min || value > max) {
            isValid = false;
            element.classList.add("error");
        } else {
            element.classList.remove("error");
        }
    }

    validateDimension(width, limits.width.min, limits.width.max, "width");
    validateDimension(height, limits.height.min, limits.height.max, "height");
    validateDimension(depth, limits.depth.min, limits.depth.max, "depth");

    if (!selectedColor) {
        isValid = false;
        alert("Please select a color!");
    }

    if (calculatedPrice <= 0 || isNaN(calculatedPrice)) {
        isValid = false;
        errorMessage.innerHTML = `<p>Error: The entered values exceed the allowed limits.</p>`;
    }

    if (!isValid) {
        errorMessage.innerHTML = `<p>Error: The entered values exceed the allowed limits.</p>`;
        return; // Зупиняємо виконання, якщо дані невірні
    }

    // Якщо всі дані валідні - відправляємо товар у кошик
    console.log("The data is correct, adding the item to the cart!");

  

    let variants = [
        { id: 44595453460630, price: 37 },
  { id: 44595453493398, price: 38 },
  { id: 44595453526166, price: 39 },
  { id: 44595453558934, price: 40 },
  { id: 44595453591702, price: 41 },
  { id: 44595453624470, price: 42 },
  { id: 44595453657238, price: 43 },
  { id: 44595453690006, price: 44 },
  { id: 44595453722774, price: 45 },
  { id: 44595453755542, price: 46 },
  { id: 44595453788310, price: 47 },
  { id: 44595453821078, price: 48 },
  { id: 44595453853846, price: 49 },
  { id: 44595453886614, price: 50 },
  { id: 44595453919382, price: 51 },
  { id: 44595453952150, price: 52 },
  { id: 44595453984918, price: 53 },
  { id: 44595454017686, price: 54 },
  { id: 44595454050454, price: 55 },
  { id: 44595454083222, price: 56 },
  { id: 44595454115990, price: 57 },
  { id: 44595454148758, price: 58 },
  { id: 44595454181526, price: 59 },
  { id: 44595454214294, price: 60 },
  { id: 44595454247062, price: 61 },
  { id: 44595454279830, price: 62 },
  { id: 44595454312598, price: 63 },
  { id: 44595454345366, price: 64 },
  { id: 44595454378134, price: 65 },
  { id: 44595454410902, price: 66 },
  { id: 44595454443670, price: 67 },
  { id: 44595454476438, price: 68 },
  { id: 44595454509206, price: 69 },
  { id: 44595454541974, price: 70 },
  { id: 44595454574742, price: 71 },
  { id: 44595454607510, price: 72 },
  { id: 44595454640278, price: 73 },
  { id: 44595454673046, price: 74 },
  { id: 44595454705814, price: 75 },
  { id: 44595454738582, price: 76 },
  { id: 44595454771350, price: 77 },
  { id: 44595454804118, price: 78 },
  { id: 44595454836886, price: 79 },
  { id: 44595454869654, price: 80 },
  { id: 44595454902422, price: 81 },
  { id: 44595454935190, price: 82 },
  { id: 44595454967958, price: 83 },
  { id: 44595455000726, price: 84 },
  { id: 44595455033494, price: 85 },
  { id: 44595455066262, price: 86 },
  { id: 44595455099030, price: 87 },
  { id: 44595455131798, price: 88 },
  { id: 44595455164566, price: 89 },
  { id: 44595455197334, price: 90 },
  { id: 44595455230102, price: 91 },
  { id: 44595455262870, price: 92 },
  { id: 44595455295638, price: 93 },
  { id: 44595455328406, price: 94 },
  { id: 44595455361174, price: 95 },
  { id: 44595455393942, price: 96 },
  { id: 44595455426710, price: 97 },
  { id: 44595455459478, price: 98 },
  { id: 44595455492246, price: 99 },
  { id: 44595455525014, price: 100 },
  { id: 44604064202902, price: 101 },
  { id: 44604076785814, price: 102 },
  { id: 44604076818582, price: 103 },
  { id: 44604076851350, price: 104 },
  { id: 44604076884118, price: 105 },
  { id: 44604076916886, price: 106 },
  { id: 44604076949654, price: 107 },
  { id: 44604076982422, price: 108 },
  { id: 44604077015190, price: 109 },
  { id: 44604077047958, price: 110 },
  { id: 44604077080726, price: 111 },
  { id: 44604077113494, price: 112 },
  { id: 44604077146262, price: 113 },
  { id: 44604077179030, price: 114 },
  { id: 44604077211798, price: 115 },
  { id: 44604077244566, price: 116 },
  { id: 44604077277334, price: 117 },
  { id: 44604077310102, price: 118 },
  { id: 44604077342870, price: 119 },
  { id: 44604077375638, price: 120 },
  { id: 44604077408406, price: 121 },
  { id: 44604077441174, price: 122 },
  { id: 44604077473942, price: 123 },
  { id: 44604077506710, price: 124 },
  { id: 44604077539478, price: 125 },
  { id: 44604077572246, price: 126 },
  { id: 44604077605014, price: 127 },
  { id: 44604077637782, price: 128 },
  { id: 44604077670550, price: 129 },
  { id: 44604077703318, price: 130 },
  { id: 44604077736086, price: 131 },
  { id: 44604077768854, price: 132 },
  { id: 44604077801622, price: 133 },
  { id: 44604077834390, price: 134 },
  { id: 44604077867158, price: 135 },
  { id: 44604077899926, price: 136 },
  { id: 44604077932694, price: 137 },
  { id: 44604077965462, price: 138 },
  { id: 44604077998230, price: 139 },
  { id: 44604078030998, price: 140 },
  { id: 44604078063766, price: 141 },
  { id: 44604078096534, price: 142 },
  { id: 44604078129302, price: 143 },
  { id: 44604078162070, price: 144 },
  { id: 44604078194838, price: 145 },
  { id: 44604078227606, price: 146 },
  { id: 44604078260374, price: 147 },
  { id: 44604078293142, price: 148 },
  { id: 44604078325910, price: 149 },
  { id: 44604078358678, price: 150 },
  { id: 44604078391446, price: 151 },
  { id: 44604078424214, price: 152 },
  { id: 44604078456982, price: 153 },
  { id: 44604078489750, price: 154 },
  { id: 44604078522518, price: 155 },
  { id: 44604078555286, price: 156 },
  { id: 44604078588054, price: 157 },
  { id: 44604078620822, price: 158 },
  { id: 44604078653590, price: 159 },
  { id: 44604078686358, price: 160 },
  { id: 44604078719126, price: 161 },
  { id: 44604078751894, price: 162 },
  { id: 44604078784662, price: 163 },
  { id: 44604078817430, price: 164 },
  { id: 44604078850198, price: 165 },
  { id: 44604078882966, price: 166 },
  { id: 44604078915734, price: 167 },
  { id: 44604078948502, price: 168 },
  { id: 44604078981270, price: 169 },
  { id: 44604079014038, price: 170 },
  { id: 44604079046806, price: 171 },
  { id: 44604079079574, price: 172 },
  { id: 44604079112342, price: 173 },
  { id: 44604079145110, price: 174 },
  { id: 44604079177878, price: 175 },
  { id: 44604079210646, price: 176 },
  { id: 44604079243414, price: 177 },
  { id: 44604079276182, price: 178 },
  { id: 44604079308950, price: 179 },
  { id: 44604079341718, price: 180 },
  { id: 44604110438550, price: 181 },
  { id: 44604110471318, price: 182 },
  { id: 44604110504086, price: 183 },
  { id: 44604110536854, price: 184 },
  { id: 44604079374486, price: 185 },
  { id: 44604079407254, price: 186 },
  { id: 44604079440022, price: 187 },
  { id: 44604079472790, price: 188 },
  { id: 44604079505558, price: 189 },
  { id: 44604079538326, price: 190 },
  { id: 44604123775126, price: 191 },
  { id: 44604123807894, price: 192 },
  { id: 44604123840662, price: 193 },
  { id: 44604123873430, price: 194 },
  { id: 44604123906198, price: 195 },
  { id: 44604123938966, price: 196 },
  { id: 44604123971734, price: 197 },
  { id: 44604124004502, price: 198 },
  { id: 44604124037270, price: 199 },
  { id: 44604124070038, price: 200 },
  { id: 44604124102806, price: 201 },
  { id: 44604124135574, price: 202 },
  { id: 44604124168342, price: 203 },
  { id: 44604124201110, price: 204 },
  { id: 44604124233878, price: 205 },
  { id: 44604124266646, price: 206 },
  { id: 44604124299414, price: 207 },
  { id: 44604124332182, price: 208 },
  { id: 44604124364950, price: 209 },
  { id: 44604124397718, price: 210 },
  { id: 44604124430486, price: 211 },
  { id: 44604124463254, price: 212 },
  { id: 44604124496022, price: 213 },
  { id: 44604124528790, price: 214 },
  { id: 44604124561558, price: 215 },
  { id: 44604124594326, price: 216 },
  { id: 44604124627094, price: 217 },
  { id: 44604124659862, price: 218 },
  { id: 44604124692630, price: 219 },
  { id: 44604124725398, price: 220 },
  { id: 44604124758166, price: 221 },
  { id: 44604124790934, price: 222 },
  { id: 44604124823702, price: 223 },
  { id: 44604124856470, price: 224 },
  { id: 44604124889238, price: 225 },
  { id: 44604124922006, price: 226 },
  { id: 44604124954774, price: 227 },
  { id: 44604124987542, price: 228 },
  { id: 44604125020310, price: 229 },
  { id: 44604125053078, price: 230 },
  { id: 44604125085846, price: 231 },
  { id: 44604125118614, price: 232 },
  { id: 44604125151382, price: 233 },
  { id: 44604125184150, price: 234 },
  { id: 44604125216918, price: 235 },
  { id: 44604125249686, price: 236 }
    ];

    // Пошук найближчого більшого або рівного варіанту
    let selectedVariant = variants
        .filter(v => v.price >= calculatedPrice) // фільтруємо варіанти, які не менші за `calculatedPrice`
        .reduce((prev, curr) => (prev.price < curr.price ? prev : curr), { price: Infinity });

    // Якщо немає більшого варіанту, вибираємо найдорожчий
    if (selectedVariant.price === Infinity) {
        selectedVariant = variants.reduce((prev, curr) => (prev.price > curr.price ? prev : curr));
    }

    console.log("🔹 Найближчий більший варіант:", selectedVariant);

    if (!selectedVariant || !selectedVariant.id) {
        alert("❌ Виберіть правильний розмір! Немає варіанту для цієї ціни.");
        return;
    }

    let formData = {
        id: selectedVariant.id,
        quantity: 1,
        properties: {
            Width: width,
            Height: height,
            Depth: depth,
            OutsideColor: selectedColor,
            EcoleatherСolor: selectedEcoleathercolor,
            Lid: hasLid,
            Unit: unit
        }
    };

    // Відправляємо запит через AJAX
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        console.log("✅ Товар додано в кошик:", data);
        // Перезавантажуємо сторінку після успішного додавання
        location.reload();
    })
    .catch(error => {
        console.error("❌ Помилка додавання в кошик:", error);
        alert("❌ Не вдалося додати товар. Спробуйте ще раз!");
    });
});

